/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
  getAllGrupoTipoActividad ({ commit }, item) {
    //console.log('GrupoTipoActividad item, ', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getGroupTipCasoByProject',
          {
            idUser: item.idUser,
            idProject: item.idProject
          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('GrupoTipoActividad', response.data)
          if (response.data.nuOK === 0 || response.data.nuOK === 1) {
            const lista = response.data.listaGroupTipCaso ? response.data.listaGroupTipCaso : []
            commit('SET_GRUPO_TIPOACTIVIDAD', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllTipoActividad ({ commit }, item) {
    //console.log('TipoActividad item, ', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getTipoActividadV2',
          {
            idCompany: item.idCompany,
            idProject: item.idProject,
            idRequestTypeService: item.idRequestTypeService,
            idGrupoRequestType: item.idGrupoRequestType
          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('TipoActividad response, ', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaTipoActividad ? response.data.listaTipoActividad : []
            commit('SET_TIPOACTIVIDAD', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllTipoActividadExterna ({ commit }, company) {
    return new Promise((resolve, reject) => {
      axios
        .post('/getTipoActividadExterna',
          { idCompany: company.idCompany, idProject: company.idProject },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('TipoActividadExterna', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaTipoActividadExterna ? response.data.listaTipoActividadExterna : []
            commit('SET_TIPOACTIVIDAD_EXTERNA', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllSubProyecto ({ commit }, company) {
    //console.log('SubProyecto item, ', company)
    return new Promise((resolve, reject) => {
      axios
        .post('/getSubproyectos',
          { idProyecto: company.idProject },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('SubProyectos', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaSubproyecto ? response.data.listaSubproyecto : []
            commit('SET_SUBPROYECTO', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllProyecto ({ commit }, company) {
    //console.log('Proyecto item, ', company)
    return new Promise((resolve, reject) => {
      axios
        .post('/getProyectosByResource',  // Método anterior: getProyectos
          {
            idCompany: company.idCompany,
            idUser: company.idUser
          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8'
              //'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('Proyectos response,', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaProyecto ? response.data.listaProyecto : []
            commit('SET_PROYECTO', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          //console.log('getAllProyecto error, ', error)
          reject(error)
        })
    })
  },
  getAllServicios ({ commit }, company) {
    //console.log('Servicios item, ', company)
    return new Promise((resolve, reject) => {
      axios
        .post('/getServicio',
          { idCompany: company.idCompany, idProject: company.idProject },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('Servicios', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaServicio ? response.data.listaServicio : []
            commit('SET_SERVICIO', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllCriticality ({ commit }, company) {
    return new Promise((resolve, reject) => {
      axios
        .post('/getCriticatily',
          { idCompany: company.idCompany, idProject: company.idProject },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('Criticality', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaCriticality ? response.data.listaCriticality : []
            commit('SET_CRITICALITY', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllItilIncidentType ({ commit }, company) {
    return new Promise((resolve, reject) => {
      axios
        .post('/getItilIncidentType',
          { idCompany: company.idCompany, idProject: company.idProject },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('ItilIncidentType', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaItilIncidentType ? response.data.listaItilIncidentType : []
            commit('SET_ITILINCIDENTTYPE', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllApplicative ({ commit }, company) {
    return new Promise((resolve, reject) => {
      axios
        .post('/getApp',
          { idCompany: company.idCompany, idProject: company.idProject },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('Applicative', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaApp ? response.data.listaApp : []
            commit('SET_APPLICATIVE', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAllHelpDesk ({ commit }, company) {
    return new Promise((resolve, reject) => {
      axios
        .post('/getHelpDeskService',
          { idCompany: company.idCompany, idProject: company.idProject },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('HelpDesk', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaHelpDeskService ? response.data.listaHelpDeskService : []
            commit('SET_HELP_DESK', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getGesActivosByUser ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/getGesActivosByUser',
          {
            idCompany: item.idCompany,
            idProject: item.idProject,
            idRequestTypeService: null,
            idUser: item.idUser
          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('GesActivos', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaGesActivo ? response.data.listaGesActivo : []
            commit('SET_GES_ACTIVOS', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAreaByResource ({ commit }, item) {
    //console.log('AreaByResource item, ', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getAreaByResource',
          {
            idProject: item.idProject,
            idUser: item.idUser
          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('AreaByResource', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaArea ? response.data.listaArea : []
            commit('SET_AREA_BY_RESOURCE', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCompanias ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post('/getCompanias',
          {
            idUsuario: item.idUser
          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('Companias', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaCompania ? response.data.listaCompania : []
            commit('SET_COMPANIES', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getResourceByProject ({ commit }, item) {
    //console.log('ResourceByProject item,', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getResourceByProject',
          {
            idUser: item.idUser,
            idProject: item.idProject
          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('ResourceByProject response,', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaResource ? response.data.listaResource : []
            commit('SET_RESOURCE_BY_PROJECT', lista)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getTipServicioByTipoCaso ({ commit }, item) {
    //console.log('TipServicioByTipoCaso item,', item)
    const payload = {
      idUser: item.idUser,
      idRequestType: item.idRequestType,
      idRequestTypeService: item.idRequestTypeService,
      idProject: item.idProject
    }
    console.log('TipServicioByTipoCaso request', payload)
    return new Promise((resolve, reject) => {
      axios
        .post('/getTipServicioByTipoCaso',
          payload,
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          console.log('TipServicioByTipoCaso response', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaTipoServicio ? response.data.listaTipoServicio : []
            commit('SET_SERVICE_TYPE_BY_CASE_TYPE', lista)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCriticidadByTipoCaso ({ commit }, item) {
    //console.log('CriticidadByTipoCaso item,', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getCriticidadByTipoCaso',
          {
            idUser: item.idUser,
            idRequestType: item.idRequestType,
            idRequestTypeCriticality: item.idRequestTypeCriticality,
            idProject: item.idProject
          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('CriticidadByTipoCaso response,', response.data)
          if (response.data.nuOK === 0) {
            const lista = response.data.listaCriticality ? response.data.listaCriticality : []
            commit('SET_CRITICALITY_BY_CASE_TYPE', lista)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getProjectAddData ({ commit }, item) {
    //console.log('ProjectAddData item,', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getProjectAddData',
          {
            idProject: item.idProject
          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('ProjectAddData response,', response.data)
          if (response.data.nuOK === 0 && response.data.v_code === 0) {
            const lista = response.data.listaProjectAddData ? response.data.listaProjectAddData : []
            commit('SET_PROJECT_ADD_DATA', lista)

            const listaIds = []
            lista.forEach(projectAddData => {
              if (projectAddData.value === 'Y') {
                listaIds.push(projectAddData.configId)
              }
            })
            commit('SET_PROJECTID_ADD_DATA', listaIds)

            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getSourceRequest ({ commit }, item) {
    //console.log('SourceRequest item,', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getSourceRequest',
          {

          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('SourceRequest response,', response.data)
          if (response.data.nuOK === 0 && response.data.v_code === 0) {
            const lista = response.data.listaSourceRequest ? response.data.listaSourceRequest : []
            commit('SET_SOURCE_REQUEST', lista)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getRequestClass ({ commit }, item) {
    //console.log('RequestClass item,', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getRequestClass',
          {

          },
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('RequestClass response,', response.data)
          if (response.data.nuOK === 0 && response.data.v_code === 0) {
            const lista = response.data.listaRequestClass ? response.data.listaRequestClass : []
            commit('SET_REQUEST_CLASS', lista)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAccountByFilter ({ commit }, item) {
    //console.log('getAccountByFilter item,', item)
    return new Promise((resolve, reject) => {
      axios
        .post('/getAccountByFilter',
          item, // {idCompany, idProject, idSubProject}
          {
            headers: {
              //Authorization: `Bearer ${  localStorage.getItem('accessToken')}`
              'Content-type': 'application/json; charset=utf-8',
              'Access-Control-Allow-Origin': '*'
            }
          })
        .then(response => {
          //console.log('getAccountByFilter response,', response.data)
          if (response.data.nuOK === 0 && response.data.v_code === 0) {
            //const lista = response.data.data ? response.data.data : []
            const lista = response.data.data ? response.data.data : []

            const tmp = []
            if (lista) {
              for (const mp in lista) {
                tmp.push({
                  id: lista[mp].id_account,
                  descripcion: lista[mp].name
                })
              }
            }
            //console.log("tmp", tmp)
            commit('SET_ACCOUNT_BY_FILTER', tmp)
            //commit('SET_ACCOUNT_BY_FILTER', lista)
            resolve(response.data)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAccountTypes({ commit }){
    return new Promise((resolve, reject) => {
      axios
        .post('/getAccountTypes')
        .then(response => {
          if (response.data.v_code === 0) {
            commit('SET_TIPOS_CUENTA', response.data.listaTipoCuenta)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getIdentificationTypes({ commit }){
    return new Promise((resolve, reject) => {
      axios
        .post('/getIdentificationTypes')
        .then(response => {
          if (response.data.v_code === 0) {
            commit('SET_TIPOS_IDENTIFICACION', response.data.listaTipoIdentificacion)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getBusinessUnit({ commit }){
    return new Promise((resolve, reject) => {
      axios
        .post('/getAllBusinessUnit')
        .then(response => {
          if (response.data.v_code === 0) {
            commit('SET_UNIDAD_NEGOCIO', response.data.listData)
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  setAllTipoActividad ({ commit }, item) {
    commit('SET_TIPOACTIVIDAD', item.lista)
  },
  setAreaByResource ({ commit }, item) {
    commit('SET_AREA_BY_RESOURCE', item.lista)
  },
  clearAllProyecto ({ commit }) {
    commit('SET_PROYECTO', [])
  },
  clearAllSubProyecto ({ commit }) {
    commit('SET_SUBPROYECTO', [])
  },
  clearAllItilIncidentType ({ commit }) {
    commit('SET_ITILINCIDENTTYPE', [])
  },
  clearAllSourceRequest ({ commit }) {
    commit('SET_SOURCE_REQUEST', [])
  },
  clearAllTipoActividadExterna ({ commit }) {
    commit('SET_TIPOACTIVIDAD_EXTERNA', [])
  },
  clearAllCriticality ({ commit }) {
    commit('SET_CRITICALITY', [])
  },
  clearAllServicios ({ commit }) {
    commit('SET_SERVICIO', [])
  },
  clearAllGrupoTipoActividad ({ commit }) {
    commit('SET_GRUPO_TIPOACTIVIDAD', [])
  },
  clearAllTipoActividad ({ commit }) {
    commit('SET_TIPOACTIVIDAD', [])
  },
  clearAllApplicative ({ commit }) {
    commit('SET_APPLICATIVE', [])
  },
  clearAllHelpDesk ({ commit }) {
    commit('SET_HELP_DESK', [])
  },
  clearAllAreaByResource ({ commit }) {
    commit('SET_AREA_BY_RESOURCE', [])
  },
  clearAllRequestClass ({ commit }) {
    commit('SET_REQUEST_CLASS', [])
  },
  clearAllGesActivosByUser ({ commit }) {
    commit('SET_GES_ACTIVOS', [])
  },
  clearAllProjectAddData ({ commit }) {
    commit('SET_PROJECT_ADD_DATA', [])
  },
  clearAllProjectIdAddData ({ commit }) {
    commit('SET_PROJECTID_ADD_DATA', [])
  },
  clearAccountByFilter ({ commit }) {
    commit('SET_ACCOUNT_BY_FILTER', [])
  },
  clearResourceByProject ({ commit }) {
    commit('SET_RESOURCE_BY_PROJECT', [])
  }
}
